<h2>{{ text().title }}</h2>
<p>{{ text().content }}</p>
<img
  class="close"
  (click)="handleCancel()"
  (keypress)="handleCancel()"
  tabindex="0"
  src="icons/close.svg"
  i18n-alt
  alt="close"
/>
<div class="actions">
  <app-button variant="primary" (click)="handleCancel()">{{ text().cancel }}</app-button>
  <app-button variant="outline-primary" (click)="handleConfirm()">{{ text().confirm }}</app-button>
</div>
